import React, { useReducer, useEffect, useCallback, useMemo } from 'react';
import { GlobalContext } from "./GlobalContext";
import { reducer } from './Reducer';
import { SET_CART_COUNT } from './ActionConstants';

type ProviderProps = {
    children: React.ReactNode;
};

const storedUser = localStorage.getItem('user');

const initialState = {
    auth: {
        token: localStorage.getItem('token'),
        refreshToken: localStorage.getItem('refreshToken'),
        user: storedUser ? JSON.parse(storedUser) : null,
    },
    cartCount: Number(localStorage.getItem('cartCount') || 0),
};

export const GlobalStateProvider = ({ children }: ProviderProps) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (state.auth.token && state.auth.user) {
            localStorage.setItem('token', state.auth.token);
            localStorage.setItem('user', JSON.stringify(state.auth.user));
            if (state.auth.refreshToken) {
                localStorage.setItem('refreshToken', state.auth.refreshToken);
            } else {
                localStorage.removeItem('refreshToken');
            }
        } else {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('refreshToken');
        }
    }, [state.auth]);

    useEffect(() => {
        localStorage.setItem('cartCount', String(Number(state.cartCount || 0)));
    }, [state.cartCount]);

    const login = useCallback((token: string, user: Record<string, unknown>, refreshToken?: string) => {
        dispatch({ type: 'LOGIN', payload: { token, user, refreshToken } });
    }, []);

    const logout = useCallback(() => {
        dispatch({ type: 'LOGOUT' });
    }, []);

    const setCartCount = useCallback((count: number) => {
        dispatch({ type: SET_CART_COUNT, payload: count });
    }, []);

    const contextValue = useMemo(
        () => ({ state, dispatch, login, logout, setCartCount }),
        [state, login, logout, setCartCount],
    );

    return (
        <GlobalContext.Provider value={contextValue}>
            {children}
        </GlobalContext.Provider>
    );
};
